import React, { useReducer } from 'react'
import AccessPersonToVisitContext from './AccessPersonToVisitContext'
import AccessPersonToVisitReducer from './AccessPersonToVisitReducer';
import { getAccessPersonsToVisitService } from '../../services/accessPersonToVisits';
import { t } from 'i18next';
import { logout } from '../../services/login';

const AccessPersonToVisitState = ({ children }) => {
    const initialState = {
        accessPersonsToVisit: [],
        totalPages: 1,
        isFetching: true,
        error: false,
        message: '',
        accessPersonsToVisitSelected: [],
    };

    const [state, dispatch] = useReducer(AccessPersonToVisitReducer, initialState)

    const cleanAccessPersonToVisitState = () => dispatch({ type: 'CLEAN' })

    const setAccessPersonsToVisitSelected = (accessPersonsToVisitSelected) => dispatch({ type: 'SET_PERSONS_TO_VISIT', payload: accessPersonsToVisitSelected });

    const getAccessPersonsToVisit = async (values) => {
        try {
            dispatch({ type: 'IS_FETCHING' });
            const response = await getAccessPersonsToVisitService(values);
            if (response.ok) {
                dispatch({
                    type: 'GET_PERSONS_TO_VISIT',
                    payload: response.data.response
                });
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('PERMISSIONS_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('ERROR_TRY_AGAIN')
            })
            console.log(e)
        }
    }

    return (
        <AccessPersonToVisitContext.Provider
            value={{
                accessPersonToVisitState: state,
                getAccessPersonsToVisit,
                setAccessPersonsToVisitSelected,
                cleanAccessPersonToVisitState
            }}
        >
            {children}
        </AccessPersonToVisitContext.Provider>
    )
}

export default AccessPersonToVisitState